import PhoneOutlinedIcon from '@ant-design/icons/PhoneOutlined'

import IconButton from '@mui/material/IconButton'

import { useVoiceWidgetState } from '@providers/VoiceWidgetStateProvider'

export default function PhoneCall({ size }) {
  const { toggle } = useVoiceWidgetState()

  return (
    <IconButton
      id="phone-call-button"
      color="secondary"
      size={size}
      onClick={() => toggle()}
      aria-label="Phone Call"
      data-testid="header-phone-call"
    >
      <PhoneOutlinedIcon style={{ fontSize: 19 }} />
    </IconButton>
  )
}
